import loaded from '@/scripts/helpers/loaded';

loaded(() => {
  const wrapParents = document.querySelectorAll(
    ".item--inner--content--seconds .wrap--parent"
  );

  wrapParents.forEach((parent, index) => {
    const titleElement = parent.querySelector(
      ".item--inner--content--seconds .h-text"
    );
    if (titleElement) {
      parent.setAttribute("x-data", `{ isOpen${index}: false }`);

      const chevronContainer = document.createElement("div");
      chevronContainer.className = "chevron";

      const chevronTop = document.createElement("div");
      chevronTop.className = "chevron-part chevron-before";
      chevronContainer.appendChild(chevronTop);

      const chevronBottom = document.createElement("div");
      chevronBottom.className = "chevron-part chevron-after";
      chevronContainer.appendChild(chevronBottom);

      titleElement.appendChild(chevronContainer);

      titleElement.setAttribute(
        "x-bind:class",
        `isOpen${index} ? 'active' : ''`
      );
      titleElement.setAttribute(
        "x-on:click",
        `isOpen${index} = !isOpen${index}`
      );
      titleElement.setAttribute("x-transition.duration.300ms", "");

      let contentElement = titleElement.nextElementSibling;
      while (contentElement) {
        contentElement.setAttribute("x-show", `isOpen${index}`);

        contentElement.setAttribute("x-transition.duration.300ms", "");

        contentElement = contentElement.nextElementSibling;
      }
    }
  });
});
